/** @format */

import { QueryClient } from "react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: Infinity,
      staleTime: 3600 * 1000 * 12,
    },
  },
});

export { queryClient };
